import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

import login from '@/common/login/store';
import appStore from '@/modules/app/store';
import workflowStore from '@/modules/workflow/store';

const store = new Vuex.Store({
    modules: {
        login,
        ...appStore,
        ...workflowStore,
    }
});
export default store;

export { store };
